import { http } from 'connex-cds';

export default {
  getCompanyAdmin: ({ entityRef }) => http.get({ apiName: 'mt', path: `/${entityRef}/master-data/entity-setup` }),
};
